import { replace } from 'react-router-redux';
import URL from 'url';

import { ActionTypes } from './constants';

export const changeProcedure = procedureId => dispatch => {
    const { hash, pathname, query } = URL.parse(window.location.href, true);

    query.reason_visit = procedureId;

    // update the URL in-place
    dispatch(
        replace({
            hash,
            pathname,
            query,
        })
    );

    /**
     * TODO: unify this with the analytics change event defined
     * on trackProcedureChange
     */
    return dispatch({
        type: ActionTypes.CHANGE_PROCEDURE,
        payload: {
            reason_visit: procedureId,
        },
    });
};
